/*eslint no-magic-numbers: 0*/
import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import Dropdown from "../../../../components/Dropdown";
import QuestionDetail from "../../components/QuestionDetail";
import NoSubscription from "../../components/NoSubscription";
import PageLoading from "../../../../components/PageLoading";
import ReportsFooter from "../../components/ReportsFooter";
import ReportsTabbar from "../../components/ReportsTabbar";

import { getSelectedReport, getVisibleReports } from "../../../../store/helpers/userHelper";

// actions
import {
  fetchUrgentActions,
  updateSelectedReport,
  fetchReports,
  fetchReportStatus,
} from "../../../../store/actions/reports.action";

import { setNavigationAssets } from "../../../../store/actions/navigation.action";

//utils
import * as data from "./data";

//scss
import "./UrgentActions.scss";
import Motivator from "../../components/Motivator/Motivator";
import PageTitle from "../../../../components/PageTitle";
import PageContent from "../../../../components/PageContent";

class UrgentActions extends Component {
  constructor(props) {
    super(props);
    this.state = {
      reportDropdown: { data: data.reportsData },
    };
    this.formStatus = {};
  }
  componentDidMount() {
    const navigation = {
      title: "METRIC REPORTS",
      subtitle: "URGENT ACTIONS",
      tab: "YOUR REPORTS",
    };
    this.props.setNavigationAssets(navigation);
    this.props.fetchUrgentActions();
  }

  updateFormFieldValue = (fieldName, fieldValue) => {
    this.setState({ [fieldName]: fieldValue }, () => {
      this.props.updateSelectedReport(fieldValue).then(() => {
        this.props.fetchReports();
        this.props.fetchReportStatus();
        this.props.fetchUrgentActions();
      });
    });
  };

  render() {
    const { isFullReport, isPageLoading, lowestScoring, greatestDisparity, isTeam360, reports } =
      this.props;

    const { reportDropdown } = this.state;

    let paragraphs = [];
    if (isTeam360) {
      paragraphs.push(
        "This section gives you the ten lowest scoring questions from your stakeholders. We have included the comparison scores from how your own team rated themselves against the same questions.",
        "If your own team has scored any of the questions significantly higher than your stakeholders, then there is clearly a disconnect that needs to be addressed."
      );
    } else {
      paragraphs.push(
        `Your urgent actions include two areas. The first are the team’s three lowest scoring questions which will give you a strong indication of where the team feels it’s weakest.`,
        `The second three questions scores are those with the great range of responses – or disparity. This shows you where the team are working and thinking very differently to each other – and a sign of lack of cohesion in these areas.`
      );
    }

    return (
      <PageLoading
        isLoading={isPageLoading}
        render={() => (
          <Fragment>
            <Motivator />
            <PageTitle title="Urgent Actions" paragraphs={paragraphs}>
              {reports && reports.length > 0 && (
                <div className="urgent-actions-page__header-title_select">
                  <Dropdown
                    data={{
                      ...reportDropdown.data,
                      list: getVisibleReports(reports) || [],
                      value: reports && getSelectedReport(reports),
                    }}
                    onSelect={this.updateFormFieldValue}
                  />
                </div>
              )}
            </PageTitle>
            <PageContent>
              <ReportsTabbar />
              {isFullReport ? (
                <div className="urgent-actions-page__content">
                  <div className="urgent-actions-page__content-subtitle">
                    <span>Lowest scoring questions</span>
                  </div>
                  {lowestScoring &&
                    lowestScoring.map((question) => (
                      <QuestionDetail
                        description={question.question_description}
                        average={question.average.toFixed(1)}
                        answers={question.answer_count}
                        answersTotal={question.total_answers}
                        id={question.question_id}
                        key={question.question_id}
                      />
                    ))}

                  <div className="urgent-actions-page__content-subtitle">
                    <span>These Questions had the greatest disparity between responses</span>
                  </div>
                  {greatestDisparity &&
                    greatestDisparity.map((question) => (
                      <QuestionDetail
                        description={question.question_description}
                        average={question.average.toFixed(1)}
                        answers={question.answer_count}
                        answersTotal={question.total_answers}
                        id={question.question_id}
                        key={question.question_id}
                      />
                    ))}
                </div>
              ) : (
                <NoSubscription reportType="Urgent Actions" />
              )}

              <ReportsFooter />
            </PageContent>
          </Fragment>
        )}
      />
    );
  }
}

UrgentActions.propTypes = {
  fetchUrgentActions: PropTypes.func,
  setNavigationAssets: PropTypes.func,
  fetchReports: PropTypes.func,
  fetchReportStatus: PropTypes.func,
  updateSelectedReport: PropTypes.func,
  greatestDisparity: PropTypes.array,
  lowestScoring: PropTypes.array,
  isLoadingUrgentActions: PropTypes.bool,
  isLoadingReports: PropTypes.bool,
  isPageLoading: PropTypes.bool,
  isFullReport: PropTypes.bool,
  isTeam360: PropTypes.bool,
  reports: PropTypes.array,
};

const mapStateToProps = ({ reports }) => {
  const isPageLoading = reports.isLoadingReports || reports.isLoadingUrgentActions;
  return {
    greatestDisparity: reports.urgentActions && reports.urgentActions.greatest_disparity_questions,
    lowestScoring: reports.urgentActions && reports.urgentActions.lowest_scoring_questions,
    isLoadingUrgentActions: reports.isLoadingUrgentActions,
    isLoadingReports: reports.isLoadingReports,
    isFullReport: reports && reports.reportStatus && reports.reportStatus.is_full_report,
    isPageLoading,
    isTeam360: reports && reports.reportStatus && reports.reportStatus.is_team_360,
    reports: reports.reports,
  };
};

export default connect(mapStateToProps, {
  setNavigationAssets,
  updateSelectedReport,
  fetchReports,
  fetchReportStatus,
  fetchUrgentActions,
})(UrgentActions);
